import * as React from 'react';
import { Theme } from '@mui/material/styles';
import { withStyles } from 'tss-react/mui';
import HideInSingleRoutineMode from '../../../SingleRoutineMode/HideInSingleRoutineMode';
import EDIconButton from '../../../../BaseComponents/Buttons/IconButton/EDIconButton';
import EDAvatar from '../../../../BaseComponents/Avatar/EDAvatar';
import EDIcon from '../../../../BaseComponents/Icon/EDIcon';
import DatabaseList from '../../../DatabaseList/DatabaseList';
import OnlyInSingleRoutineMode from '../../../SingleRoutineMode/OnlyInSingleRoutineMode';
import EDTypography from '../../../../BaseComponents/Typography/EDTypography';
import {
  IDatabase,
  LoginStateContext,
} from '../../../../Features/Login/Contexts/LoginStateContext/LoginStateContext';
import EDBox from '../../../../BaseComponents/EDBox/EDBox';
import { APP_NAVBAR_HEIGHT_PX } from '../../../../BaseComponents/ThemeProvider/AvenyTheme';

interface IProps {
  showEnhetSelector?: boolean;
  databases: IDatabase[];
  activeDatabase?: IDatabase;
  currentPath: string;
  renderTaskMenuButton: () => React.ReactNode;
  onUserMenuClick: (event: React.MouseEvent<HTMLElement>) => void;
  isLoggedIn?: boolean;
  classes?: any;
}

const styles = (theme: Theme) => ({
  toolbarRight: {
    display: 'flex',
    flex: '1 1 0%',
    justifyContent: 'flex-end',
    alignItems: 'center',
    height: APP_NAVBAR_HEIGHT_PX,
    [theme.breakpoints.down('sm')]: {
      flex: '0',
      justifySelf: 'flex-end',
      paddingLeft: 0,
    },
  },
  dbList: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      margin: 0,
    },
  },
  profileAvatar: {
    width: theme.spacing(4),
    height: theme.spacing(4),
  },
});

const AppNavBarStandardToolbarBase: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  const {
    classes,
    showEnhetSelector = false,
    databases,
    activeDatabase,
    isLoggedIn = false,
  } = props;
  const loginState = React.useContext(LoginStateContext);
  return (
    <div className={classes.toolbarRight}>
      <React.Fragment>
        {showEnhetSelector && (
          <EDBox className={classes.dbList}>
            <OnlyInSingleRoutineMode>
              <EDTypography color="inherit" variant="body2">
                {props.activeDatabase?.name}
              </EDTypography>
            </OnlyInSingleRoutineMode>
            <HideInSingleRoutineMode>
              <DatabaseList
                size="small"
                databases={databases}
                selectedDatabases={activeDatabase ? [activeDatabase] : []}
                showLabel
                fixedWidth
              />
            </HideInSingleRoutineMode>
          </EDBox>
        )}
        {props.renderTaskMenuButton()}
        <EDIconButton
          onClick={props.onUserMenuClick}
          disabled={!isLoggedIn}
          tooltip={loginState.name}
          icon={
            <EDAvatar className={classes.profileAvatar}>
              <EDIcon color="inherit" iconType="person" size="medium" />
            </EDAvatar>
          }
          margin="dense"
          padding="none"
          noLeftMargin
          noTopMargin
          noBottomMargin
          testId="userMenuButton"
        />
      </React.Fragment>
    </div>
  );
};

export const AppNavBarStandardToolbar = withStyles(
  AppNavBarStandardToolbarBase,
  styles
);
